import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import TabHeader from "root/components/TabHeader";
import { consts as uploaderConsts } from "uploader";
import t from "common/i18n";
import Button from "root/components/Button";
import useCurrentPage from "../../hooks/useCurrentPage";
import { useSearchParams, useSelectedAsset, useAssets } from "../../selectors";
import { getInternalPath } from "../../utils";
import { ROUTES } from "../../data/consts";
import SVGs from "~/assets/icons/icons";


export default ({ handleLogout, handleSearch, handleClearSearchTerm, handleTogglePanel, isFiltersPanelOpen, areFiltersSet }) => {
	const history = useHistory();
	const [searchPhraseLocal, setSearchPhraseLocal] = useState("");
	const { searchPhrase } = useSearchParams();
	const { isSummaryPage } = useCurrentPage();
	const { selectedAsset } = useSelectedAsset();
	const { items } = useAssets();

	useEffect(() => {
		setSearchPhraseLocal(searchPhrase);
	}, [searchPhrase]);
	
	const clearSearchTerm = useCallback(() => {
		handleClearSearchTerm({ searchPhrase: searchPhraseLocal });
	}, [handleClearSearchTerm, searchPhraseLocal]);
	
	const onSearch = useCallback(() => {
		handleSearch({ searchPhrase: searchPhraseLocal });
	}, [handleSearch, searchPhraseLocal]);

	const handlePurchaseBack = useCallback(() => {
		if (items.length) {
			history.push(getInternalPath(ROUTES.SEARCH));
		}
		else {
			history.push(getInternalPath(ROUTES.HOME));
		}
	}, [history, items]);
	return (
		<TabHeader
			source={uploaderConsts.SOURCES.ISTOCK}
			searchTerm={searchPhraseLocal}
			expandSearch
			hideBackButton
			onLogout={handleLogout}
			searchClickHandler={onSearch}
			searchTermHandler={setSearchPhraseLocal}
			clearBtnTip={t("search.reset")}
			showClearButton={!!searchPhraseLocal}
			onClearClickHandler={clearSearchTerm}
			onEscClickHandler={clearSearchTerm}
			titleCenter={isSummaryPage && selectedAsset.title}
			searchInputPlaceholder={t("search.placeholder")}
			showBackButton={isSummaryPage}
			showSearch={!isSummaryPage}
			onBackNavigation={handlePurchaseBack}
		>
			{!isSummaryPage && <Button
				dataTest="filters-button"
				textColorName="menu-icons"
				icon={isFiltersPanelOpen ? SVGs.LT_ARROW : SVGs.SLIDERS}
				iconSize={isFiltersPanelOpen ? 22 : "sm"}
				fontSize={12}
				onClick={handleTogglePanel}
				showIndicator={areFiltersSet && !isFiltersPanelOpen}
			/>}
		</TabHeader>
	);
};
